import type { ReactNode } from 'react';

/**
 * Full-bleed `.paper-2` strip used at the top of list views (Materials
 * Queue, PCOs, Reconciliation). Holds tab-style filter links with mono
 * counts and an optional right-side meta cluster (sort indicator, etc.).
 *
 * Per "design not content": each filter chip's count comes from the real
 * collection length, not a fixture. Pass `count={undefined}` to hide the
 * count entirely (data still loading); pass `count={0}` to render "0".
 */
export function FilterBar({ children }: { children: ReactNode }) {
  return <div className="filter-bar">{children}</div>;
}

export interface FilterChipProps {
  active: boolean;
  count?: number;
  onClick?: () => void;
  children: ReactNode;
}

export function FilterChip({ active, count, onClick, children }: FilterChipProps) {
  return (
    <a
      className={active ? 'active' : undefined}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onClick();
        }
      }}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
      {typeof count === 'number' && <span className="n">{count}</span>}
    </a>
  );
}

/**
 * Pushes any following children to the right side of the filter bar.
 */
export function FilterBarSpacer() {
  return <span className="grow" />;
}

export function FilterBarRight({ children }: { children: ReactNode }) {
  return <div className="right">{children}</div>;
}
